export default __webpack_public_path__ + "static/Tyler-Simoni-Resume-cd7752c822c41a74b7029b567d290dfd.pdf";